module.exports = require("./ms-ID.d.ts");